import { ServerCommunicationUtil } from './server_communication_util';
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const facebookHandler = (response, locale, successCallback = () => {}, errorCallback = () => {}, completeCallback = () => {}) => {
  if (!response.accessToken) {
    return;
  }

  const fbData = {
    facebook_id: response.userID,
    facebook_token: response.accessToken,
    facebook_expires: response.expiresIn,
    create_session: true
  };
  const headers = locale ? { 'X-Language-Locale': locale } : {};

  ServerCommunicationUtil.postApiEndpoint('/api/alltrails/facebook/login', fbData, successCallback, errorCallback, completeCallback, headers);
};

const appleHandler = () => {
  const redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
    StringConstantsMixin.constants.APPLE_SIWA.REDIRECT_PATH
  }`;
  const authUrl = `${StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_URL +
    StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_PARAMS}&client_id=${
    StringConstantsMixin.constants.APPLE_SIWA.CLIENT_ID
  }&redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(StringConstantsMixin.constants.APPLE_SIWA.SCOPES)}`;
  window.location = authUrl;
};

const googleHandler = (googleUser, locale, successCallback = () => {}, errorCallback = () => {}, completeCallback = () => {}) => {
  const token = googleUser.getAuthResponse().id_token;
  const data = { google_token: token, create_session: true };
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  ServerCommunicationUtil.postApiEndpoint('/api/alltrails/google/login', data, successCallback, errorCallback, completeCallback, headers);
};

export { facebookHandler, appleHandler, googleHandler };
